import { useEffect } from 'react';
import '../../../../shared/src/common/css/scheduler.css';
import SchedulerSteps from '@leadflow/shared/src/feature/scheduler/components/SchedulerStep/SchedulerSteps';
import ThemeProviderWrapper from '../../theme/ThemeContext';
import { SchedulerConfig } from '@leadflow/shared/src/Interface/scheduler/form';
import { FormProvider } from '@leadflow/shared/src/common/contexts/FormContext';
import { SharedStateProvider } from '@leadflow/shared/src/common/contexts/SharedStateContext';
import { useFormConfigContext } from '@leadflow/shared/src/common/contexts/FormConfigContext';
import { schedulerConfigJsonSequence } from '@leadflow/shared/src/common/components/Helper/Helper';

const App = () => {
  const { setFormConfig } = useFormConfigContext();

  useEffect(() => {
    const mojInlineFormConfig = document.getElementById('data');
    if (mojInlineFormConfig?.textContent) {
      try {
        const mojJsonData = JSON.parse(
          mojInlineFormConfig.textContent,
        ) as SchedulerConfig;
        if (mojJsonData?.conceptid) {
          const formatData = schedulerConfigJsonSequence(mojJsonData);
          setFormConfig(formatData);
        }
      } catch (error) {
        console.error('Failed to parse JSON:', error);
      }
    } else {
      fetch('/config-files/_scheduler-config.json')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((mojData) => {
          if (mojData?.steps) {
            const formatData = schedulerConfigJsonSequence(mojData);
            setFormConfig(formatData);
          }
        })
        .catch((error) => console.error('Error fetching MOJ config:', error));
    }
  }, []);

  return (
    <ThemeProviderWrapper>
      <FormProvider>
        <SharedStateProvider>
          <SchedulerSteps />
        </SharedStateProvider>
      </FormProvider>
    </ThemeProviderWrapper>
  );
};

export default App;
